import type { RouterScrollBehavior } from 'vue-router';

import { HEADER_CSS_CLASS, SCROLL_TO_OFFSET } from '@/plugins/layout/lib/LayoutUtils';

type ScrollBehavior = ReturnType<RouterScrollBehavior>;

export const scrollBehavior: RouterScrollBehavior = to => {
  if (to.hash) {
    const output: ScrollBehavior = {
      el: to.hash,
      behavior: 'smooth',
    };

    const headerEl = document.querySelector(`.${HEADER_CSS_CLASS}`);

    if (headerEl) {
      const { height } = headerEl.getBoundingClientRect();

      output.top = height + SCROLL_TO_OFFSET;
      output.left = 0;
    }

    return output;
  } else {
    return { left: 0, top: 0 };
  }
};
